import { Moment } from 'moment-timezone';

export interface Order {
    uuid: string;
    marketplaceId: number;
    customerId: number;

    issuedAt: Moment;

    items: Array<OrderItem>;
}

export type SaveOrder = Order;

export interface OrderItem {
    uuid: string;
    marketplaceId: number;
    petId: number;
    staffId?: number;

    orderizableId: number;
    orderizableType: OrderizableType;

    quantity: number;
    amount: number;
    discount: number;
    description: string;

    startedAt?: Moment;
}

export type SaveOrderItem = OrderItem;

export enum OrderizableType {
    AddonService = 'AddonService'
}
